module.exports = __webpack_public_path__ + "img/Stairs.ef462145.svg";